import React, { useState, useEffect, useMemo } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { getData, putData } from "../../FetchNodeServices";
import { useSelector } from "react-redux";
import Select from "react-select";
import AlertMessages from "../Mains/Alerts";

const BillingDetail = (props) => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyDomain, setCompanyDomain] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  // const [countryName, setCountryName] = useState("");
  const [countryId, setCountryId] = React.useState("");
  const [stateId, setStateId] = React.useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [alerts, setAlerts] = useState([]);

  // const countryNameRef = useRef();
  // const stateNameRef = useRef();

  const customer = useSelector((state) => state.user.users[0]);
  const user = useMemo(() => customer?.userId || "", [customer]);
  const account = useMemo(() => customer?.accountId || "", [customer]);

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleCountryChange = (selectedOption) => {
    setCountryId(selectedOption.value);
    // fetchState(selectedOption.value);
    // alert(selectedOption.value);
  };

  const fetchCountry = async () => {
    setIsLoading(true);
    let result = await getData("users/country");
    setCountryList(result);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  const fillCountry = () => {
    return countryList.map((item) => {
      return { value: item.countryId, label: item.countryName };
    });
  };

  const fetchState = async (countryId) => {
    setIsLoading(true);
    var result = await getData("users/country/state-list/" + countryId);
    setStateList(result);


    setIsLoading(false);
  };


  useEffect(() => {
    if (countryId) {
      fetchState(countryId);
    }
  }, [countryId]);

  const fillState = () => {
    // if (stateList.length !== 0) {
    if (!Array.isArray(stateList)) {
      return [];
    }

    return stateList.map((item) => {

      return { value: item.stateName, label: item.stateName };
    });
    // }
  };


  const handleStateChange = (selectedOption) => {
    setStateId(selectedOption.value);


    // fetchState(event.target.value);
  };


  const handleSubmit = async () => {
    setIsLoading(true);
    var FormData = {
      userId: user,
      accountId: account,
      companyName: companyName,
      companyDomain: companyDomain,
      companyAddressLineOne: companyAddress,
      country: countryId,
      state: stateId,
      city: city,
      zipcode: pincode,
    };
    var result = await putData("users/billing-details", FormData);
    if (result) {
      // alert("User Added Successfully!");
      setAlerts([{ variant: "success", heading: "Details Added Successfully!" }]);

      // setIsLoading(false);
    } else {
      // alert("Something went wrong!");
      setAlerts([{ variant: "danger", heading: "Something went wrong!" }]);
    }
    setIsLoading(false);
  };

  // const handleClear = () => {
  //   setCompanyName("");
  //   setCompanyDomain("");
  //   setCompanyAddress("");
  //   setCountryId("");
  //   setStateId("");
  //   setCity("");
  //   setPincode("");
  // };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <span className="breadcrumb_slash">/</span>
              <li>
                <i className="bi bi-people"></i> Customer Admin
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i>Billing Details
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <div>
              <span className="step_count">1</span> Basic Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count active">2</span> Billing Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count">3</span> Branding
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyName}
                      placeholder="Please enter registered legal name for billing"
                      onChange={(event) => setCompanyName(event.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Domain</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyDomain}
                      placeholder="Enter Company Domain"
                      onChange={(event) => setCompanyDomain(event.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyAddress}
                      placeholder="Enter Address"
                      onChange={(event) => setCompanyAddress(event.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">City</label>
                    <input type="text" className="form-control" value={city} placeholder="Enter City" onChange={(event) => setCity(event.target.value)} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Country</label>
                    <Select
                      options={fillCountry()}
                      value={fillCountry().find((option) => option.value === countryId)}
                      onChange={handleCountryChange}
                      placeholder="Enter country"
                      isSearchable
                    />

                    {/* <input
                      type="text"
                      ref={countryNameRef}
                      onClick={(e) => {
                        countryNameRef.current.value = "";
                      }}
                      defaultValue={props.selectedRecord.countryNameRef}
                      list="item_name_list"
                    />
                    <datalist id="item_name_list">
                      {countryList.map((item, index) => {
                        return <option key={item.countryId} value={item.countryName} />;
                      })}
                    </datalist> */}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">State</label>
                    {/* <Select
                      options={fillState()}
                      value={fillState().find((option) => option.value === stateId)}
                      onChange={handleStateChange}
                      placeholder="Enter State"
                      isSearchable
                    /> */}

                    {stateList.length === 0 ? (
                      <input
                        type="text"
                        id="state"
                        className="form-control"
                        placeholder="Enter state"
                        value={stateId}
                        onChange={(e) => setStateId(e.target.value)} // Add onChange event handler
                      />
                    ) : (
                      <Select

                        options={fillState()}
                        value={fillState().find((option) => option.value == stateId)}
                        onChange={(selectedOption) => handleStateChange(selectedOption)}
                        placeholder="Enter State"
                        isSearchable
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">PIN Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={pincode}
                      placeholder="Enter pincode"
                      onChange={(event) => setPincode(event.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <div className="button_group">
                  <Link to="/ebasic-detail">
                    <button type="button" className="btn btn-light text-grey me-3">
                      <i className="bi bi-chevron-left me-1"></i> Back
                    </button>
                  </Link>
                  {/* <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>
                    Clear Values
                  </button> */}
                </div>
                <div className="button_group">
                  <Link to="/branding">
                    <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()}>
                      Next
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDetail;
